import React, { useMemo } from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import BedbankCancellationPolicy from './BedbankCancellationPolicy'
import BedbankPromotionCancellationPolicy from 'components/OfferPage/Bedbank/BedbankPromotionCancellationPolicy'
import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  checkInDate?: string
  checkOutDate?: string
  onlySalePeriod?: boolean
  promotion: App.BedbankPromotion
  rate?: App.BedbankRate | App.OrderBedbankRate
  showNonCancellation?: boolean
}

function BedbankPromotionDetails(props: Props) {
  const {
    checkInDate,
    checkOutDate,
    onlySalePeriod,
    promotion,
    rate,
    showNonCancellation,
  } = props

  const validCheckInCheckoutDates = !!(checkInDate && checkOutDate)

  const [fromDate, toDate] = useMemo(() => ([moment(promotion.travelPeriod.from), moment(promotion.travelPeriod.to)]), [promotion])

  return <VerticalSpacer gap={8}>
    {rate && <BedbankCancellationPolicy
      rate={rate}
      showNonCancellation={!!showNonCancellation}
    />}
    {!validCheckInCheckoutDates && promotion.cancellationPolicy && <BedbankPromotionCancellationPolicy
      policyCode={promotion.cancellationPolicy}
    />}
    {!onlySalePeriod && <div>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        <FormattedMessage
          id="0busa2BKDq"
          defaultMessage="Travel between {dateRange}"
          description="Travel date range for promotional rate"
          values={{
            dateRange: <FormatDateTimeRange startValue={fromDate} endValue={toDate} format="dmy-casual" />,
          }}
        />
      </BodyText>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        <FormattedMessage
          id="b/zC2zkUvc"
          defaultMessage="Min stay: {nights, plural, one {# night} other {# nights}}"
          description="Minimum night stay requirement"
          values={{ nights: promotion.los }}
        />
      </BodyText>
    </div>}
  </VerticalSpacer>
}

export default BedbankPromotionDetails
